/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { gql } from '@apollo/client';
import { object } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { GRAPHQL_ENV } from '../../../gql';
import HtmlSitemapBuilder from './HtmlSitemapBuilder';

const HtmlSitemapContainer = ({ page, brand }) => {
    const HTML_SITEMAP_PAGE_QUERY = gql`
        query HtmlSitemapQery {
            findContentPage(brand: "${brand['domain-name']}",url: "${page.path}", environment: "${GRAPHQL_ENV}", contentType: "${page.contentType}", locale: "en-us") {
                content
            }
        }`;

    return (
        <Query query={HTML_SITEMAP_PAGE_QUERY}>
            {({ loading, data, error }) => {
                if (loading) {
                    return <div style={{ height: '100vh' }} />;
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: HTML_SITEMAP_PAGE_QUERY,
                        component: 'HtmlSitemapContainer.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: HTML_SITEMAP_PAGE_QUERY,
                        component: 'HtmlSitemapContainer.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                let sitemapData = null;
                if (data.findContentPage) {
                    sitemapData = data.findContentPage;
                }
                return (
                    <>
                        {sitemapData && <HtmlSitemapBuilder sitemapData={sitemapData} />}
                    </>
                );
            }}
        </Query>

    );
};

HtmlSitemapContainer.propTypes = {
    page: object.isRequired,
    brand: object.isRequired,
};

export default HtmlSitemapContainer;
